export const environment = {
  production: false,
  backendUrl: 'https://stg-measurement-api.conversionomics.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyAEhA1r2GjGuC09We1qs6ZbL24u4HRQG9M',
    authDomain: 'nc-tracking-stg.firebaseapp.com',
    projectId: 'nc-tracking-stg',
    storageBucket: 'nc-tracking-stg.firebasestorage.app',
    messagingSenderId: '538692437144',
    appId: '1:538692437144:web:df21f9d369e27cb9efbced'
  }
};
